import { createContext, JSX } from 'react';
import { AppConfig } from '../types/Common';

interface ConfigurationProviderProps {
  children: JSX.Element;
  config: AppConfig;
}

export const ConfigurationContext = createContext<AppConfig | null>(null);
export default function ConfigurationProvider({ children, config }: ConfigurationProviderProps) {
  return <ConfigurationContext.Provider value={config}>{children}</ConfigurationContext.Provider>;
}
